import APP_CONFIG from "../configs/environment";

export const EngageGPTAuthProvider: any = APP_CONFIG.appSettingsData.federatedEngageAIProvider;
